
import $ from "jquery"
import "bootstrap-tap"

const selector = {
  scope:  ".cell--cities--transit-info--modal",
  tabs:   ".modal-transit__btn-group",
  btn:    ".js-btn-select-group",
}

const init = () => {
  $(selector.scope).each((idx, el) => {
    const $el = $(el)
    const $tabs = $el.find(selector.tabs)
    const $btn = $tabs.find(selector.btn)

    // # Register the event
    $btn.on("click", (e) => {
      e.preventDefault()

      const $this = $(e.target)

      // # This switch tab
      $this.tab("show")
      // # This creates the button switch effect
      // $tab_btn_group.find(".active").removeClass("active")
      $this.addClass("active")
    })
  })
}

export default {init}
